module.exports = __webpack_public_path__ + "resources/img/img_watchall_nms1_jp.8017edcdf2ab25cdc7769e5117c03945.png";